import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=10ef6d34&"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports